export interface RequestInputApiModel {
    author_emails: string[];
    story_title: string;
    campaign_id: number;
    story_prompt: any;
    story_requested: any;
    question_id_campaign?:any
}